import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { YotpoContextProvider } from "../contexts/YotpoContext.jsx";

import ReviewsContainer from "../components/yotpo/ReviewsContainer.jsx"

const YotpoProductReviews = ({basePath, apiKey, searchOptions}) => {

  return (
    <div className="ft_yotpo-component">
      <Router basename={basePath}>
        <YotpoContextProvider apiKey={apiKey}>
          <Route exact path='/'>
            <ReviewsContainer searchOptions={searchOptions ? searchOptions.split(",") : []}/>
          </Route>
        </YotpoContextProvider>
      </Router>
    </div>
  );

}

export default YotpoProductReviews;
